module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoRg.7aba95e5.otf";